import type { Lang } from "../../i18n/translations";
import type { Theme } from "../types";

export function LangSegment({
  theme,
  lang,
  setLang,
}: {
  theme: Theme;
  lang: Lang;
  setLang: (l: Lang) => void;
}) {
  const isDark = theme === "dark";
  const trackBg = isDark
    ? "bg-white/10 border-white/10"
    : theme === "transparent"
      ? "bg-white/70 border-ink-100 backdrop-blur"
      : "bg-ink-50 border-ink-100";
  const inactive = isDark ? "text-white/55 hover:text-white" : "text-ink-500 hover:text-ink-900";
  const active = isDark ? "bg-white text-ink-900" : "bg-ink-900 text-white";
  return (
    <div
      className={
        "inline-flex items-center rounded-full border p-0.5 text-[10.5px] font-semibold tracking-wide shadow-soft " +
        trackBg
      }
      role="group"
      aria-label="Language"
    >
      {(["tr", "en"] as const).map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={
            "px-2 py-0.5 rounded-full transition " + (lang === l ? active : inactive)
          }
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
